module.exports = __webpack_public_path__ + "assets/img/title-83edc01c.png";